<template>
	<header class="prebuild-hero">
		<div class="container">
			<div class="row">
				<div class="col-md-7 col-lg-8">
					<div class="prebuild-hero__info-container">
						<div class="prebuild-hero__text">
							<h1 class="prebuild-hero__name">
								{{ seriesInfo.title }}
							</h1>
							<h4 class="prebuild-hero__tagline">
								{{ seriesInfo.description }}
							</h4>
							<a
								class="prebuild-hero__see-specs btn"
								v-scroll-to="{
									el: '#prebuild-specs',
									offset: -50
								}"
								@click="trackShowSpecsClick"
							>
								See Specs
							</a>
						</div>
						<gallery-showcase :images="getGalleryImages" />
					</div>
				</div>
				<div class="col-md-5 col-lg-4">
					<product-card
						:prebuilds-list="prebuilds"
						:variants-list="getCurrentPrebuildVariants"
						:games-performance="gamesPerformance"
						:current-prebuild="getCurrentPrebuild"
						:current-variant="getCurrentVariant"
						:shipping-info="getshippingInfo"
						@set-prebuild="setCurrentPrebuild"
						@set-variant="setCurrentVariant"
					/>
				</div>
			</div>
		</div>
	</header>
</template>

<script>
import GalleryShowcase from "./gallery-showcase";
import ProductCard from "./product-card";
import { gtmMap, gtmTrigger, gtmTrack } from "@/util/gtm";

export default {
	name: "HeroSection",
	inject: ["currentPrebuild", "gamesPerformance"],
	components: {
		GalleryShowcase,
		ProductCard
	},
	props: {
		seriesInfo: {
			type: Object,
			default() {
				return {};
			}
		},
		prebuilds: {
			type: Array,
			default() {
				return [];
			}
		}
	},
	computed: {
		getshippingInfo() {
			const { sections = [] } = this.seriesInfo;
			const [shippingInfo = {}] = sections;
			return shippingInfo;
		},
		getCurrentPrebuild() {
			const { getPrebuild } = this.currentPrebuild;
			return getPrebuild();
		},
		getCurrentPrebuildVariants() {
			const { variants = [] } = this.getCurrentPrebuild;
			return variants;
		},
		getCurrentVariant() {
			const { getVariant } = this.currentPrebuild;
			return getVariant();
		},
		getGalleryImages() {
			const { gallery = [] } = this.getCurrentVariant;
			return gallery;
		}
	},
	methods: {
		setCurrentPrebuild(payload) {
			const { setPrebuild } = this.currentPrebuild;
			setPrebuild(payload);
		},
		setCurrentVariant(variant) {
			const { setVariantId } = this.currentPrebuild;
			setVariantId(variant.id);
		},
		trackShowSpecsClick() {
			gtmTrack.prebuildShowSpecs();
			gtmTrigger.showSpecs(
				gtmMap.prebuildSeriesToProduct(this.getCurrentVariant)
			);
		}
	}
};
</script>

<style lang="scss" scoped>
.prebuild-hero {
	background: linear-gradient(180deg, rgba(81, 0, 122, 0.6) 0%, #000000 100%);

	.container {
		padding-top: 20px;

		@media (min-width: 580px) and (max-width: 991px) {
			padding-top: 65px;
			width: 100%;
		}

		@media (min-width: 991px) {
			margin-bottom: 110px;
			padding-top: 90px;
		}
	}

	&__info-container {
		display: flex;
		flex-direction: column-reverse;
		align-items: center;

		@media (min-width: 991px) {
			flex-direction: column;
			align-items: initial;
		}
	}

	&__text {
		text-align: center;

		@media (min-width: 991px) {
			text-align: left;
		}
	}

	&__name {
		color: #ffffff;
		font-size: 32px;
		font-weight: bold;
		letter-spacing: 0;
		margin: 0;

		@media (min-width: 580px) and (max-width: 1200px) {
			font-size: 48px;
		}

		@media (min-width: 1200px) {
			font-size: 64px;
		}
	}

	&__tagline {
		color: rgba(#ffffff, 0.7);
		font-size: 16px;
		letter-spacing: 0;
		margin: 0 0 25px;

		@media (min-width: 580px) {
			font-size: 24px;
		}

		@media (min-width: 991px) and (max-width: 1200px) {
			font-size: 20px;
		}
	}

	&__see-specs {
		border: 1px solid #fafafa;
		border-radius: 2px;
		font-size: 14px;
		color: #fff;
		background: transparent;
		font-weight: bold;
		padding: 5px 43px;
		text-transform: capitalize;
		margin-bottom: 30px;

		@media (min-width: 580px) and (max-width: 991px) {
			margin-bottom: 65px;
		}

		@media (hover: hover) {
			&:hover {
				color: #51007a;
				background: #fafafa;
			}
		}
	}
}
</style>
